module.exports = __webpack_public_path__ + "static/media/administrar.a1eddfde.svg";